import { rootApi } from 'root-api'

import { CONTACT_BY_EMAIL_QUERY } from './constants'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['CONTACT'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchContactByEmailGQL: build.query({
      query: (email) => ({
        url: '/api/oap-api/graphql',
        method: 'POST',
        data: {
          query: CONTACT_BY_EMAIL_QUERY,
          variables: { email }
        }
      }),
      extraOptions: {
        handleErrors: false
      },
      transformResponse: (res) => res?.data?.contactByEmail,
      providesTags: ['CONTACT']
    }),
  })
})

export const {
  useFetchContactByEmailGQLQuery,
} = api
